class TimeLine extends HTMLElement {
  constructor() {
    super();
    this.sliderWrapper = this.querySelector('.time-line__slider-wrapper');
    this.slides = this.querySelectorAll('.time-line__slide');
    this.navItems = this.querySelectorAll('.time-line__navigation-item');
    this.progressLine = this.querySelector('.time-line__progress-line');

    this.btnPrev = this.querySelector('.time-line__btn-prev');
    this.btnNext = this.querySelector('.time-line__btn-next');

    this.currentIndex = 0;
    this.currentSize = this.slides.length;
    this.rafPending = false;

    this.navigateSlider();
    this.buttonsSlider();
    this.highlightOnScroll();
  }

  // Scroll position that brings slide `index` to the same on-screen spot the
  // first slide occupies at rest. Uses the real slide offsets, so it is exact
  // for any number of items and any slide width.
  targetForIndex(index) {
    const slide = this.slides[index];
    if (!slide) return 0;
    const max = this.sliderWrapper.scrollWidth - this.sliderWrapper.clientWidth;
    const target = slide.offsetLeft - this.slides[0].offsetLeft;
    return Math.max(0, Math.min(target, max));
  }

  navigateSlider() {
    this.navItems.forEach((item, index) => {
      item.addEventListener('click', () => {
        this.currentIndex = index;
        this.moveSlider();
        this.setActiveSlide(this.currentIndex);
        this.visibilitySliderButtons(this.currentIndex, this.currentSize);
      });
    });
  }

  highlightOnScroll() {
    this.sliderWrapper.addEventListener('scroll', () => {
      if (this.rafPending) return;
      this.rafPending = true;
      requestAnimationFrame(() => {
        this.rafPending = false;
        const wrapper = this.sliderWrapper;
        const scrollLeft = wrapper.scrollLeft;
        const base = this.slides[0] ? this.slides[0].offsetLeft : 0;
        const max = wrapper.scrollWidth - wrapper.clientWidth;
        const last = this.slides.length - 1;

        // The last slide can't scroll fully left (no content after it), so use
        // each slide's *reachable* scroll position, capped at max. This lets
        // the progress line and the active state reach the very end.
        const reachable = [];
        this.slides.forEach((slide) => {
          reachable.push(Math.min(slide.offsetLeft - base, max));
        });

        // Progress line: fractional position that glides with the scroll.
        let fraction = last;
        for (let i = 0; i < last; i++) {
          if (scrollLeft < reachable[i + 1]) {
            const span = reachable[i + 1] - reachable[i];
            fraction = span > 0 ? i + (scrollLeft - reachable[i]) / span : i;
            break;
          }
        }

        // Active slide: nearest reachable target.
        let closest = 0;
        let min = Infinity;
        reachable.forEach((target, i) => {
          const distance = Math.abs(target - scrollLeft);
          if (distance < min) {
            min = distance;
            closest = i;
          }
        });

        this.currentIndex = closest;
        this.progressLine.style.transform = `translateX(${fraction * 100}%)`;
        this.setActiveSlide(closest);
        this.visibilitySliderButtons(closest, this.currentSize);
      });
    });
  }

  buttonsSlider() {
    this.btnPrev.addEventListener('click', () => {
      this.currentIndex--;
      this.moveSlider();
      this.setActiveSlide(this.currentIndex);
      this.visibilitySliderButtons(this.currentIndex, this.currentSize);
    });

    this.btnNext.addEventListener('click', () => {
      this.currentIndex++;
      this.moveSlider();
      this.setActiveSlide(this.currentIndex);
      this.visibilitySliderButtons(this.currentIndex, this.currentSize);
    });
  }

  setActiveSlide(index) {
    index = Math.max(0, Math.min(index, this.slides.length - 1));
    this.slides.forEach((s) => s.setAttribute('data-active', 'false'));
    if (this.slides[index]) this.slides[index].setAttribute('data-active', 'true');
  }

  visibilitySliderButtons(index, size) {
    index <= 0
      ? this.btnPrev.setAttribute('data-active', 'false')
      : this.btnPrev.setAttribute('data-active', 'true');

    index >= size - 1
      ? this.btnNext.setAttribute('data-active', 'false')
      : this.btnNext.setAttribute('data-active', 'true');
  }

  moveSlider() {
    this.currentIndex = Math.max(0, Math.min(this.currentIndex, this.slides.length - 1));
    this.sliderWrapper.scrollTo({ left: this.targetForIndex(this.currentIndex), behavior: 'smooth' });
  }
}
customElements.define('time-line', TimeLine);
